import {
  Card,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText
} from "@mui/material";
import { HidroLayer, HidroLayerGroup } from "./layers";
import { CenterFocusWeak, Delete } from "@mui/icons-material";

interface ContextMenuProps {
  x: number;
  y: number;
  show: boolean;
  onClose: () => void;
  layer: HidroLayer | HidroLayerGroup;
}
export const LayerContextMenu: React.FC<ContextMenuProps> = ({ layer, x, y, show, onClose }) => {
  if (!show) return null;

  const windowHeight = window.innerHeight;
  const windowWidth = window.innerWidth;
  const itemWidth = 250;
  const itemHeight = 350;

  if (windowWidth < x + itemWidth + 15) x = x - itemWidth;
  if (windowHeight < y + itemHeight + 15) y = y - itemHeight;

  const layerMoter = layer.getMother();
  const bounds = layer.getBounds();

  const removeHandler = () => {
    onClose();
    if (!layerMoter) return;
    layerMoter.removeLayer(layer);
  };

  return (
    <Card sx={{
      position: 'absolute',
      top: `${y}px`,
      left: `${x}px`,
      zIndex: 10000,
      border: "1px solid black"
    }}>
      <List>
        {/* Remover Layer */}
        {layerMoter && layerMoter instanceof HidroLayerGroup &&
          <ListItem disablePadding>
            <ListItemButton onClick={removeHandler}>
              <ListItemText primary="Remover Layer" />
              <ListItemIcon>
                <Delete />
              </ListItemIcon>
            </ListItemButton>
          </ListItem>}

        {/* Zoom to Layer */}
        {bounds && <ListItem disablePadding>
          <ListItemButton onClick={() => layer.centerBounds()}>
            <ListItemText primary="Aproximar" />
            <ListItemIcon>
              <CenterFocusWeak />
            </ListItemIcon>
          </ListItemButton>
        </ListItem>}
      </List>
    </Card>
  );
};